import * as React from 'react';
export const mastercardSvg = React.forwardRef(function mastercardSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 4.035A4.831 4.831 0 0 1 9.848 7.84 4.831 4.831 0 0 1 8 11.643a4.832 4.832 0 0 1-1.85-3.804A4.831 4.831 0 0 1 8 4.035Zm-.62-.414a5.541 5.541 0 0 0-1.943 4.22 5.54 5.54 0 0 0 1.942 4.219 4.84 4.84 0 1 1 .001-8.44Zm1.24 8.439a5.54 5.54 0 0 0 1.943-4.219 5.541 5.541 0 0 0-1.944-4.22 4.84 4.84 0 1 1 .002 8.439Z',
    }),
  );
});
mastercardSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mastercard = {
  category: 'paymentmethod',
  colorable: true,
  name: 'mastercard',
  svg: mastercardSvg,
};
